export default __webpack_public_path__ + "static/media/warehousegame.23a350fd.png";